import { AbTestAction } from '../actions/abtest';
import { ReduxStore } from '../interfaces/store';

const initialState: ReduxStore['abTests'] = {};

const abTestReducer = (
  state = initialState,
  action: AbTestAction
): ReduxStore['abTests'] => {
  switch (action.type) {
    case 'SET_AB_TEST_VARIANT':
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          variant: action.payload.variant
        }
      };
    case 'MARK_AB_TEST_PENDING_EVENT': {
      const entry = state[action.payload.key];
      if (!entry) return state;
      const existing = entry.pendingEvents ?? [];
      if (existing.includes(action.payload.event)) return state;
      return {
        ...state,
        [action.payload.key]: {
          ...entry,
          pendingEvents: [...existing, action.payload.event]
        }
      };
    }
    case 'CONSUME_AB_TEST_PENDING_EVENT': {
      const entry = state[action.payload.key];
      if (!entry?.pendingEvents) return state;
      const next = entry.pendingEvents.filter(e => e !== action.payload.event);
      return {
        ...state,
        [action.payload.key]: {
          ...entry,
          pendingEvents: next.length ? next : undefined
        }
      };
    }
    default:
      return state;
  }
};

export default abTestReducer;
